
export default class {
    didMount() {
        setTimeout(() => {
            // this.models.m2.set({
            //     childName: '子名字随便啦'
            // });
        }, 7000)
    }
}